import { useState, useEffect, useCallback } from 'react';
import { getApiBaseUrl } from '../utils/api';

const API_BASE_URL = getApiBaseUrl();

const useCertificatesData = (user) => {
  // State for certificates data
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  // Pagination state
  const [certificatesPagination, setCertificatesPagination] = useState({
    current_page: 1,
    per_page: 25,
    total: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false
  });

  // Search states
  const [certificateSearchTerm, setCertificateSearchTerm] = useState("");
  const [certificateSearchQuery, setCertificateSearchQuery] = useState("");

  // Fetch certificates function
  const fetchCertificates = useCallback(async (page = 1, search = "") => {
    if (!user?.id) {
      console.error("User ID not available");
      return;
    }
    
    try {
      setLoading(true);
      const params = new URLSearchParams({
        user_id: user.id,
        page: page,
        per_page: 25
      });
      
      if (search) {
        params.append("search", search);
      }
      
      const response = await fetch(`${API_BASE_URL}/admin/certificates?${params}`);
      const data = await response.json();
      setCertificates(data.certificates || []);
      setCertificatesPagination(
        data.pagination || {
          current_page: page,
          per_page: 25,
          total: 0,
          total_pages: 0,
          has_next: false,
          has_prev: false
        }
      );
    } catch (error) {
      console.error("Error fetching certificates:", error);
      setError("Erro ao carregar certificados");
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  // Initialize data on mount
  useEffect(() => {
    if (user?.id) {
      fetchCertificates();
    }
  }, [user?.id, fetchCertificates]);

  return {
    // Data
    certificates,
    
    // States
    loading,
    error,
    setError,
    
    // Pagination
    certificatesPagination,
    
    // Search
    certificateSearchTerm,
    setCertificateSearchTerm,
    certificateSearchQuery,
    setCertificateSearchQuery,
    
    // Functions
    fetchCertificates
  };
};

export default useCertificatesData;
